import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { CommonText } from '../bumpViews/commonText';
import { IoMdClose } from 'react-icons/io';
const SidebarOverlay = styled.div `
  position: fixed;
  display: ${({ isSidebarOpen }) => (isSidebarOpen ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
`;
const SidebarWrapper = styled.div `
  position: fixed;
  height: 100vh;
  background: #fff;
  z-index: 11;
  top: 0;
  right: 0;
  transition: 0.25s;
  ${({ isOpen }) => isOpen
    ? css `
          width: 380px;
        `
    : css `
          width: 0;
          *,
          div {
            display: none;
          }
        `}
`;
const SideBarHeader = styled.div `
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  svg {
    cursor: pointer;
  }
`;
const SidebarBody = styled.div `
  height: calc(100% - 56px);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media (max-width: 1370px) {
    height: calc(100% - 100px);
  }
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #D9D9D9;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;
const SidebarBodyTop = styled.div `
  padding: 16px;
  margin-bottom: 20px;
`;
const FooterWrapper = styled.div `
  position: fixed;
  display: flex;
  padding: 12px 24px 24px 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-top: 1px solid #dfdfdf;
  background: #fefefe;
  width: 380px;
  bottom: 0;
`;
export const Sidebar = ({ isOpen, headerTitle, onClose, children }) => {
    useEffect(() => {
        const scrollRootElement = document.getElementById('scroll-root');
        if (scrollRootElement && isOpen) {
            scrollRootElement.style.overflowY = 'hidden';
        }
        if (scrollRootElement && !isOpen) {
            scrollRootElement.style.overflowY = 'scroll';
        }
    }, [isOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SidebarOverlay, { isSidebarOpen: isOpen }),
        React.createElement(SidebarWrapper, { isOpen: isOpen },
            React.createElement(SideBarHeader, null,
                React.createElement(CommonText, { size: "large", weight: 600, color: "#0C202A" }, headerTitle),
                React.createElement(IoMdClose, { size: 24, onClick: onClose })),
            children)));
};
export const SidebarBodySection = SidebarBody;
export const SidebarBodySectionTop = SidebarBodyTop;
export const FooterSection = FooterWrapper;
//# sourceMappingURL=index.js.map